<template>
  <div v-if="tabs" class="tab-panel-container py-2 px-3">
    <DxTabPanel height="70%">
      <DxItem v-for="(tab, index) in tabs" :key="index" :title="tab.title" class="tab-item" :disabled="tab.disabled">
        <component :is="tab.component" v-bind="tab.props"></component>
      </DxItem>
    </DxTabPanel>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useIntl } from '@services/i18n';
import DxTabPanel, { DxItem } from 'devextreme-vue/tab-panel';
import OfertasGrid from '@/components/ofertas-energia/base/OfertasEnergiaGrid.vue';
import ServiciosGrid from '@/components/servicios-energia/base/ServiciosEnergiaGrid.vue';
import RappelsGrid from '@/components/rappels-energia/RappelsEnergiaGrid.vue';
import RetroComisionesGrids from '@/components/retrocomisiones-energia/RetrocomisionesEnergiaGrids.vue';
import AnexosEmpresaServiciosGrid from '@/components/empresas-servicios/energia/AnexosEmpresaServiciosGrid.vue';
import { Constants } from '@constants/OperacionEnergia';

const props = defineProps({
  idEmpresaServicios: String
});

const intl = useIntl();

const mostrarGestionAnexos = computed(() =>
  !!props.idEmpresaServicios &&
  Constants.EmpresaServicios.EMPRESAS_CON_ANEXO_PLANTILLA.some(
    (id) => id.toLowerCase() === props.idEmpresaServicios!.toLowerCase()
  )
);

const tabs = computed(() => {

  const baseTabs: any[] = [];

  if (mostrarGestionAnexos.value) {
    baseTabs.push({
      title: intl.i18n.t('anexos_empresa_servicios.tab.titulo'),
      component: AnexosEmpresaServiciosGrid,
      props: { idEmpresaServicios: props.idEmpresaServicios },
      disabled: false,
    });
  }

  baseTabs.push(...[
    { title: intl.i18n.t('ofertas.titulo'), component: OfertasGrid, props: { idEmpresaServicios: props.idEmpresaServicios }, disabled: false },
    { title: intl.i18n.t('servicios.titulo'), component: ServiciosGrid, props: { idEmpresaServicios: props.idEmpresaServicios }, disabled: false },
    { title: intl.i18n.t('rappels.titulo'), component: RappelsGrid, props: { idEmpresaServicios: props.idEmpresaServicios }, disabled: false },
    { title: intl.i18n.t('retrcomisiones.titulo'), component: RetroComisionesGrids, props: { idEmpresaServicios: props.idEmpresaServicios }, disabled: false },
  ]);

  return baseTabs;
});

</script>

<style lang="scss" scoped>


.tab-panel-container {
  background-color: var(--background-surface-default);
  border: 1px solid var(--border-default-default);
  border-radius: 5px;
}

.dx-tabpanel-container {
  padding-top: 15px;
}
</style>